// extracted by mini-css-extract-plugin
export default {"popup-wrapper":"style_popup-wrapper__LZL9c","popup":"style_popup__pc436","popup-text":"style_popup-text__9hWKU","close-btn":"style_close-btn__Ve6Yp"};